import { map } from 'lodash';

const config = {
  VERSION: process.env.VERSION,
};

export default config;

export const SERVER_API_URL = process.env.SERVER_API_URL;

export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  IBAN_WRITE: 'ROLE_IBAN_WRITE',
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
};

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_LOCAL_DATETIME_FORMAT_Z = 'YYYY-MM-DDTHH:mm Z';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';

export const DEVICES_ARRAY = new Map([
  ['EUR', '€'],
  ['USD', '$'],
  [undefined, ''],
]);

export const SEARCH_CLAIM_BY_INDEX = new Map([
  [1, ['search by name', 'api']],
  [2, ['search by Claim ', 'api']],
  [3, ['search by Adhsion', 'api']],
  [4, ['Error in search Param : only caracter for name  , length of claim :10 , lengt of adhesion :12']],
]);
export const COUNTRY_ARRAY = new Map([
  ['FR', 'France'],
  ['SP', 'Espagne'],
  ['IT', 'Italie'],
]);
